function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Fragment } from 'react';
import { Divider } from '@cbhq/cds-web/layout';
import { componentsThemeMap } from '../../componentsThemeMap.js';
import { SectionComponentLayout } from '../../layout/SectionComponentLayout.js';
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import '../../ui/Link/index.js';
import { Text } from '../../ui/Text.js';
import { HighlightBlockQuoteAuthor } from './HighlightBlockQuoteAuthor.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Link } from '../../ui/Link/Link.js';
import { Div } from '../../ui/Div/Div.js';
function HighlightBlockQuote({
  quote,
  style = 'default',
  authorPhotoUrl,
  authorName,
  authorTitle,
  hasSpacingTop,
  anchor,
  link,
  linkLabel,
  isFullWidth = false
}) {
  if (!quote) return null;
  const _componentsThemeMap$s = componentsThemeMap[style],
    foreground = _componentsThemeMap$s.foreground,
    foregroundSecondary = _componentsThemeMap$s.foregroundSecondary,
    background = _componentsThemeMap$s.background;
  const quoteColor = style === 'dark' || style === 'primary' || style === 'darkwash' ? foreground : foregroundSecondary;
  const divider = style === 'default' && /*#__PURE__*/jsx(Divider, {});
  const LinkContainer = link && linkLabel ? Link : Fragment;
  const linkProps = link && linkLabel ? {
    href: link
  } : {};
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "HighlightBlockQuote",
      children: /*#__PURE__*/jsxs(SectionComponentLayout, {
        hasSpacingTop: hasSpacingTop,
        hasSpacingHorizontal: true,
        background: background,
        fullViewportWidth: isFullWidth,
        anchor: anchor,
        children: [divider, /*#__PURE__*/jsx(LinkContainer, _objectSpread(_objectSpread({}, linkProps), {}, {
          children: /*#__PURE__*/jsxs(Div, {
            flexDirection: "column",
            spacingVertical: {
              sm: 8,
              md: 9,
              lg: 10
            },
            gap: {
              sm: 3,
              md: 5
            },
            children: [/*#__PURE__*/jsxs(Text, {
              as: "p",
              variant: {
                sm: 'body',
                md: 'display2'
              },
              color: quoteColor,
              children: ["\"", quote, "\""]
            }), /*#__PURE__*/jsx(HighlightBlockQuoteAuthor, {
              color: foreground,
              secondaryColor: foregroundSecondary,
              photoUrl: authorPhotoUrl,
              name: authorName,
              title: authorTitle,
              linkLabel: linkLabel
            })]
          })
        })), divider]
      })
    })
  });
}
export { HighlightBlockQuote };
//# sourceMappingURL=HighlightBlockQuote.js.map
